/**
 * O que mostrar na coluna "2ª contagem" do inventário (2026-10-05).
 *
 * Antes a tela abria campo de recontagem em TODO item já contado — inclusive
 * nos que não divergiram (o backend recusava) e para a própria pessoa que fez
 * a 1ª contagem (o backend recusava também, item por item, numa parede de
 * texto). Agora o campo só aparece onde dá para gravar.
 *
 * - "editavel": divergiu, não foi recontado nem dispensado, e quem está na
 *   tela não é quem contou primeiro;
 * - "outra_pessoa": precisa de recontagem, mas quem está na tela fez a 1ª;
 * - "dispensada": quem aprova dispensou (com justificativa);
 * - "valor": mostra a 2ª contagem (ou "—").
 */
export function situacaoDaRecontagem(item, { emRecontagem, podeContar, usuarioId }) {
  if (item.recontagem_dispensada_em) return "dispensada";
  if (!emRecontagem || !podeContar || !item.precisa_recontagem) return "valor";
  if (item.contado_por_1 && usuarioId && item.contado_por_1 === usuarioId) return "outra_pessoa";
  return "editavel";
}
